import { render, staticRenderFns } from "./FarmsStatusCard.vue?vue&type=template&id=5cd8af5c&scoped=true&"
import script from "./FarmsStatusCard.vue?vue&type=script&lang=js&"
export * from "./FarmsStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./FarmsStatusCard.vue?vue&type=style&index=0&id=5cd8af5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd8af5c",
  null
  
)

export default component.exports